module.exports = __webpack_public_path__ + "9af2b1b41410a9cc5f85f34f443477b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-7.jpg
// module id = 81
// module chunks = 0